import Lottie from "lottie-react";
import { FC } from "react";

import SuccessLottie from "../../../../../../assets/lottie/97240 success.json";
import ErrorLottie from "../../../../../../assets/lottie/Animation - 1713527600375.json";
import HurrayLottie from "../../../../../../assets/lottie/Animation - 1713527603542.json";
import LoadingLottie from "../../../../../../assets/lottie/Animation - 1713527606102.json";
import { PyButton } from "../../../../../../components";

type TOpState =
  | "FetchingLoyalty"
  | "AlreadyEnrolled"
  | "EnrollingForLoyalty"
  | "EnrolledForLoyalty"
  | "FailedLoyalty";

type TProps = {
  open: boolean;
  operationState: TOpState;
  merchantName?: string;
  isRetryLoading?: boolean;
  onRetry: () => void;
  onProceed: () => void;
};

export const LoyaltyEnrollmentModal: FC<TProps> = ({
  open,
  operationState,
  merchantName,
  isRetryLoading = false,
  onRetry,
  onProceed,
}) => {
  if (!open) {
    return null;
  }

  const displayName = merchantName || "this store";

  return (
    <div className="fixed inset-0 z-40 bg-black/30 flex items-center justify-center p-4">
      <div className="w-full max-w-[520px] min-h-[420px] rounded-2xl bg-white border border-py_black-100 py-8 px-6 md:px-10 flex items-center">
        <div className="text-center w-full">
          <Lottie
            className={`mx-auto block mb-8 ${
              operationState === "FetchingLoyalty"
                ? "w-[60px] h-[60px] md:w-[80px] md:h-[80px]"
                : "w-[120px] h-[120px] md:w-[200px] md:h-[200px]"
            }`}
            animationData={
              operationState === "FetchingLoyalty" ||
              operationState === "EnrollingForLoyalty"
                ? LoadingLottie
                : operationState === "AlreadyEnrolled"
                  ? SuccessLottie
                  : operationState === "EnrolledForLoyalty"
                    ? HurrayLottie
                    : ErrorLottie
            }
            loop={true}
          />

          <h3 className="text-base mb-1 font-semibold text-py_black-950">
            {(operationState === "FetchingLoyalty" ||
              operationState === "EnrollingForLoyalty") && (
              <>All good things are coming your way!</>
            )}
            {operationState === "AlreadyEnrolled" && (
              <>You already have a loyalty programme from {displayName}</>
            )}
            {operationState === "EnrolledForLoyalty" && (
              <>
                You have been successfully enrolled on a loyalty programme and
                rewards from {displayName}
              </>
            )}
            {operationState === "FailedLoyalty" && (
              <>Oops! It's not you, it's us!</>
            )}
          </h3>

          <p className="text-sm font-normal text-py_black-950">
            {(operationState === "FetchingLoyalty" ||
              operationState === "EnrollingForLoyalty") && (
              <>
                You are being enrolled on the best loyalty programme from{" "}
                {displayName}
              </>
            )}
            {operationState === "AlreadyEnrolled" && (
              <>You already have a loyalty programme from {displayName}</>
            )}
            {operationState === "EnrolledForLoyalty" && (
              <>
                Proceed to explore and apply loyalty points and rewards to your
                purchase.
              </>
            )}
            {operationState === "FailedLoyalty" && (
              <>We could not enroll you on a loyalty programme right now.</>
            )}
          </p>

          {operationState === "FailedLoyalty" && (
            <div className="flex flex-col gap-4 mt-8">
              <PyButton loading={isRetryLoading} click={onRetry}>
                Try again
              </PyButton>
              <PyButton click={onProceed} variant="Secondary">
                Proceed to Checkout
              </PyButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
